import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';

const monthList = [
    {
        value: 10,
        label: '1~10장(500원)',
    },
    {
        value: 20,
        label: '11~20장(1,000원)',
    },
    {
        value: 30,
        label: '21~30장(1,500원)',
    },
    {
        value: 40,
        label: '31~40장(2,000원)',
    },
    {
        value: 50,
        label: '41~50장(2,500원)',
    },
    {
        value: 60,
        label: '51~60장(3,000원)',
    },
    {
        value: 70,
        label: '61~70장(3,500원)',
    },
    {
        value: 80,
        label: '71~80장(4,000원)',
    },
    {
        value: 90,
        label: '81~90장(4,500원)',
    },
    {
        value: 100,
        label: '91~100장(5,000원)',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
}));

export default function PrinterUse() {
    const classes = useStyles();

    const [month, setMonth] = React.useState();
    const [cabinet, setCabinet] = React.useState();
    const [cabinetList, setCabinetList] = React.useState([]);


    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();


    const [isSelected, setIsSelected] = React.useState(false);
    const onMonthChange = event => {
        if (!isSelected) {

            setMonth(event.target.value);

            setBill(event.target.value, cabinet);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);
    };


    const [isSelected2, setIsSelected2] = React.useState(false);
 


    useEffect(() => {

        //테이블 리스트
        /*
        fetchDefault('/Cabinet/GetAvailableCabinetList?month=2',
            (data) => {
                setCabinetList([data][0]);
                if ([data][0][0].id) {
                    setCabinet([data][0][0].id);

                    //계산
                    setBill(month, [data][0][0].id);
                }
            }
        );
        */

        return () => {
        }
    }, []);

    const setBill = (month, cabinetId) => {
        fetchDefault('/Printer/GetPrintBill?printNum=' + month,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }


    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>프린터 사용하기</h2>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 인쇄 매수를 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="매수"
                        className={classes.textField}
                        value={month}
                        onChange={onMonthChange}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {monthList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
               
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} usePoint={usePoint} myPoint={myPoint}  totalPrice={totalPrice} />
                </Grid>

                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Printer/PayPrint?printNum=' + month} />
                </Grid>
            </Grid>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/PrinterUse.js